import React, { useRef, useEffect, useState } from 'react'
import { Badge, Button, Form, Overlay, Popover } from 'react-bootstrap'

export const Problems = [
    { complaint: ["Lumps", "Pain", "Discharge", "Self-exam", "Breast-feeding"], area: "Breast" },
    { complaint: ["Chest pain or discomfort","Tightness","Papitations","Shortness of breadth with activity","Difficulty Breathing lying down","Swelling","Sudden awakening from sleep with shortness of breadth"], area: "Cardiovascular"},
    { complaint: ["Decreased hearing","Ringing in Ears","Earache","Drainage"], area: "Ears" },
    { complaint: ["Heat or cold intolerance","Sweating","Frequent urination","Thirst","Change in appetite"], area: "Endocrine" },
    { complaint: ["Swallowing difficulties","Change in appetite","Change in Bowel Habits","Constipation","Yellow eyes or skin","Heartburn","Nausea","Rectal bleeding","Diarrhea"], area: "Gastro-intestinal" },
    { complaint: ["Weight loss or gain","Fever or chills","Trouble sleeping","Fatigue","Weakness"], area: "General" },
    { complaint: ["Ease of Bruising","Ease of bleeding"], area: "Heamatologic" },
    { complaint: ["Muscle or joint pain","Back pain","Swelling of joints","Stiffness","Redness of joints","Trauma"], area: "Musculoskeletal" },
    { complaint: ["Lumps","Pain","Swollen glands","Stiffness"], area: "Neck" },
    { complaint: ["Dizziness","Seizures","Numbness","Tremore","Fainting","Weakness","Tingling"], area: "Neurological" },
    { complaint: ["Nervousness","Depression","Stress","Memory loss"], area: "Psychiatric" },
    { complaint: ["Cough","Coughing up blood","Wheezing","Sputum","Shortness of breadth","Painful breathing"], area: "Respiratory" },
    { complaint: ["Raises","Itching","Color changes","Lumps","Dryness","Hair and nail changes"], area: "Skin" },
    { complaint: ["Bleeding","Sore tongue","Sore throat","Trush","Dentures","Dry mouth","Hoarseness","Non-healing sores"], area: "Throat" },
    { complaint: ["Calf pain with walking","Leg cramping"], area: "Vascular" },
    { complaint: ["Frequency","Burning or pain","Incontinence","Urgency","Blood in urine","Change in urinating strength"], area: "Urinary" },
    { complaint: ["Vision Loss/Changes","Pain","Blurry or double vision","Specks","Cataracts","Redness","Flashing lights","Glaucoma","Last eye exam"], area: "Eyes" },
    { complaint: ["Stuffness","Itching","Nosebleeds","Discharge","Hay fever","Sinus pain"], area: "Nose" },
    { complaint: ["Headache","Neck pain","Head injury"], area: "Head" }
]

const PreFormCol = ({ selectedComplaints, setSelectedComplaints }) => {
    const [target, setTarget] = useState(null);
    const [showIndex, setShowIndex] = useState(null);
    const ref = useRef(null);

    const handleCheckboxChange = (area, complaint) => {
        setSelectedComplaints((prev) => {
            const areaComplaints = prev[area] || [];
            if (areaComplaints.includes(complaint)) {
                return {
                    ...prev,
                    [area]: areaComplaints.filter((comp) => comp !== complaint),
                };
            } else {
                return {
                    ...prev,
                    [area]: [...areaComplaints, complaint],
                };
            }
        });
    };

    const getComplaintCount = (area) => selectedComplaints[area]?.length || 0;

    const handleClick = (event, index) => {
        setShowIndex(index === showIndex ? null : index);
        setTarget(event.target);
    };

    // Outside click logic
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={ref}>
            {Problems.map((problem, index) => (
                <div key={problem.area} style={{ display: 'inline-block', margin: '5px' }}>
                    <Button
                        className='fs-xs m-2 mt-0'
                        variant="secondary"
                        onClick={(e) => handleClick(e, index)}
                    >
                        {problem.area}
                        {getComplaintCount(problem.area) > 0 && (
                            <Badge style={{ marginLeft: "4px", fontSize: "10px" }} bg="success" pill>
                                {getComplaintCount(problem.area)}
                            </Badge>
                        )}
                    </Button>

                    <Overlay
                        target={target}
                        show={showIndex === index}
                        placement="top"
                        container={ref}
                        containerPadding={20}
                    >
                        <Popover style={{ minWidth: '300px', maxWidth: '500px' }} id={`popover-${problem.area}`}>
                            <Popover.Header as="h3">Select complaint</Popover.Header>
                            <Popover.Body className='row gap-3'>
                                {problem.complaint.length ? problem.complaint.map((comp) => (
                                    <Form.Check
                                    style={{maxWidth: '300px' }}
                                        key={comp}
                                        type="checkbox"
                                        label={comp}
                                        className='col-5'
                                        checked={selectedComplaints[problem.area]?.includes(comp) || false}
                                        onChange={() => handleCheckboxChange(problem.area, comp)}
                                    />
                                )) : (
                                    <p className='text-muted'>No complaints listed</p>
                                )}
                            </Popover.Body>
                        </Popover>
                    </Overlay>
                </div>
            ))}
        </div>
    );
};

export default PreFormCol;
